import dayjs from "dayjs";
import "./records-user-zal.css";

/** Хинт для зала */
const RecordsUserZal = ({ user, qty }) => {
  // console.log(user)
  const img = user.imageId ? `${process.env.REACT_APP_API_BASE_URL}/api/image/${user.imageId}.jpg` : "/images/room.svg"
  return (
    <div className="records-user-zal">
      <div className="records-user-zal-header">
        <img src={img} alt="room" className="records-user-zal-icon" />
        <div>
          <div className="records-user-zal-title">{user.name}</div>
          <div className="records-user-zal-description">{user.description || 'Описание зала'}</div>
        </div>
      </div>
      <div className="records-user-zal-stats">
        <div>Всего записей {user.totalRecords || qty || 0}</div>
        {/* <div>Отменено {user.cancelledRecords || 0}</div>
        <div>Пришло {user.attendedRecords || 0}</div>
        <div>Ожидаем {user.expectedRecords || 0}</div> */}
      </div>
    </div>
  );
};

export default RecordsUserZal;
